import { Schema } from "js-data";
import * as PASchema from "./PAdbSchema";
import * as _ from "lodash"

import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default
} from "./PAdbSchema";


// PPA Model
export const WB_PPA_Model = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Model', // optional
    description: 'Schema for WB_PPA_Model records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "MODEL_ID": {
            "type": "string",
            "length": 50
        },
        "MODEL_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "OPERATION_MODE": {
            "type": "string",
            "length": 10
        },
        "WB_MDSET_ID": {
            "type": "number",
            "default": 0
        },
        "WB_SALESORG_ID": {
            "type": "number",
            "default": 0
        },
        "START_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "END_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "COMMENTS": {
            "type": "string",
            "default": "",
            "length": 1333
        },
        "WB_PRDH_ID": {
            "type": "number",
            "default": 0
        },
        "PRICE_PRDTYPE_LOCKED_IND": {
            "type": "string",
            "length": 1
        },
        "PRICE_UTILITY_FUNCTION_TYPE_ID": {
            "type": "string",
            "length": 50
        },
        "PRICE_UTILITY_FUNCTION_EXP": {
            "type": "string",
            "length": 1000
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number",
            "default": 0
        },
        "CHANNEL_ATTRIB_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Model_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SalesOrg]: {
            foreignKey: 'WB_SALESORG_ID',
            foreignKeyImmutable: true,
            localField: 'SalesOrg'
        },
    },
    hasMany: {
        [PASchema.esWB_PPA_Market]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarkets'
        },
        [PASchema.esWB_PPA_Adjustment]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAAdjustments'
        }
    }
};

// PPA Market
export const WB_PPA_Market = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Market', // optional
    description: 'Schema for WB_PPA_Market records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_MARKET_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "MARKET_ID": {
            "type": "string",
            "length": 50
        },
        "MARKET_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_CUST_ID_REF": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Market_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_Customer]: {
            foreignKey: 'WB_CUST_ID_REF',
            foreignKeyImmutable: true,
            localField: 'CustomerRef'
        }
    },
    hasMany: {
        [PASchema.esWB_PPA_Consumer_Segment]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPARespondents'
        },
        [PASchema.esWB_PPA_Market_CSR]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarketCSRs'
        }
    }
};

// PPA Channel
export const WB_PPA_Channel = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Channel', // optional
    description: 'Schema for WB_PPA_Channel records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_CHANNEL_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "CHANNEL_ID": {
            "type": "string",
            "length": 50
        },
        "CHANNEL_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Channel_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        }
    },
    hasMany: {}
};

// PPA Brand
export const WB_PPA_Brand = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Brand', // optional
    description: 'Schema for WB_PPA_Brand records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_BRAND_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "BRAND_ID": {
            "type": "string",
            "length": 50
        },
        "BRAND_NAME": {
            "type": "string",
            "default": "",
            "length": 10
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_MANUFACTURER_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PRDGRP_ID_REF": {
            "type": "number",
            "default": 0
        },
        "BRAND_ADJUSTMENT_FACTOR": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Brand_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Manufacturer]: {
            foreignKey: 'WB_PPA_MANUFACTURER_ID',
            foreignKeyImmutable: true,
            localField: 'PPAManufacturer'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID_REF',
            foreignKeyImmutable: true,
            localField: 'PPGRef'
        }
    },
    hasMany: {
        [PASchema.esWB_PPA_SubBrand]: {
            foreignKey: 'WB_PPA_BRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPASubBrands'
        }
    }
};

// PPA Sub Brand
export const WB_PPA_SubBrand = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_SubBrand', // optional
    description: 'Schema for WB_PPA_SubBrand records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_SUBBRAND_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "SUBBRAND_ID": {
            "type": "string",
            "length": 50
        },
        "SUBBRAND_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_BRAND_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PRDGRP_ID_REF": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_SubBrand_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Brand]: {
            foreignKey: 'WB_PPA_BRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPABrand'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID_REF',
            foreignKeyImmutable: true,
            localField: 'PPGRef'
        }
    },
    hasMany: {}
};

// PPA Attribute
export const WB_PPA_Attribute = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_SubBrand', // optional
    description: 'Schema for WB_PPA_SubBrand records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_ATTRIBUTE_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "ATTRIBUTE_ID": {
            "type": "string",
            "length": 50
        },
        "ATTRIBUTE_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "PRICE_PRDTYPE_IND": {
            "type": "string",
            "length": 1
        },
        "PRICE_PRDTYPE_ORDER": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Attribute_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        }
    },
    hasMany: {
        [PASchema.esWB_PPA_Attribute_Level]: {
            foreignKey: 'WB_PPA_ATTRIBUTE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAAttributeLevels'
        }
    }
};

// PPA Attribute Level
export const WB_PPA_Attribute_Level = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Attribute_Level', // optional
    description: 'Schema for WB_PPA_Attribute_Level records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_ATTRIBUTE_LEVEL_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "LEVEL_ID": {
            "type": "string",
            "length": 50
        },
        "LEVEL_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_ATTRIBUTE_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Attribute_Level_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Attribute]: {
            foreignKey: 'WB_PPA_ATTRIBUTE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAAttribute'
        }
    },
    hasMany: {}
};

// PPA Price Product Type
export const WB_PPA_PricePrdType = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_PricePrdType', // optional
    description: 'Schema for WB_PPA_PricePrdType records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_PRICEPRDTYPE_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "PRICE_TYPE_NAME": {
            "type": "string",
            "default": "",
            "length": 500
        },
        "PRICE_TYPE_LOGICAL_KEY": {
            "type": "string",
            "length": 500
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_PricePrdType_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        }
    },
    hasMany: {}
};

// PPA Price Product Type Level
export const WB_PPA_PricePrdType_Level = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_PricePrdType_Level', // optional
    description: 'Schema for WB_PPA_PricePrdType_Level records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_PRICEPRDTYPE_LEVEL_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_PRICEPRDTYPE_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRICELEVEL_ID": {
            "type": "number",
            "default": 0
        },
        "RETAIL_PRICE": {
            "type": "number",
            "default": 0
        },
        "MIN_PRICE": {
            "type": "number",
            "default": 0
        },
        "MAX_PRICE": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_PricePrdType_Level_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_PricePrdType]: {
            foreignKey: 'WB_PPA_PRICEPRDTYPE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAPriceType'
        },
        [PASchema.esWB_PPA_PriceLevel]: {
            foreignKey: 'WB_PPA_PRICELEVEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAPriceLevel'
        }
    },
    hasMany: {}
};

// PPA Product
export const WB_PPA_Product = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Product', // optional
    description: 'Schema for WB_PPA_Product records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_PRODUCT_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "PRODUCT_ID": {
            "type": "string",
            "length": 50
        },
        "PRODUCT_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_MANUFACTURER_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_BRAND_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_SUBBRAND_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_CHANNEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRICEPRDTYPE_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PROD_ID_REF": {
            "type": "number",
            "default": 0
        },
        "WB_PRDGRP_ID_REF": {
            "type": "number",
            "default": 0
        },
        "SCENARIO_PRODUCT_IND": {
            "type": "string",
            "length": 1
        },
        "RETAIL_PRICE": {
            "type": "number",
            "default": 0
        },
        "LIST_PRICE": {
            "type": "number",
            "default": 0
        },
        "COGS": {
            "type": "number",
            "default": 0
        },
        "EQV_FACTOR": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Manufacturer]: {
            foreignKey: 'WB_PPA_MANUFACTURER_ID',
            foreignKeyImmutable: true,
            localField: 'PPAManufacturer'
        },
        [PASchema.esWB_PPA_Brand]: {
            foreignKey: 'WB_PPA_BRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPABrand'
        },
        [PASchema.esWB_PPA_SubBrand]: {
            foreignKey: 'WB_PPA_SUBBRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPASubBrand'
        },
        [PASchema.esWB_PPA_Channel]: {
            foreignKey: 'WB_PPA_CHANNEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAChannel'
        },
        [PASchema.esWB_PPA_PricePrdType]: {
            foreignKey: 'WB_PPA_PRICEPRDTYPE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAPriceType'
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: 'WB_PROD_ID_REF',
            foreignKeyImmutable: true,
            localField: 'ProductRef'
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: 'WB_PRDGRP_ID_REF',
            foreignKeyImmutable: true,
            localField: 'PPGRef'
        }
    },
    hasMany: {
        [PASchema.esWB_PPA_Product_Attribute]: {
            foreignKey: 'WB_PPA_PRODUCT_ID',
            foreignKeyImmutable: true,
            localField: 'PPAProductAttributes'
        }
    }
};

// PPA Product Attribute
export const WB_PPA_Product_Attribute = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Product_Attribute', // optional
    description: 'Schema for WB_PPA_Product_Attribute records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_PRODUCT_ATTRIBUTE_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_PRODUCT_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_ATTRIBUTE_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_ATTRIBUTE_LEVEL_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Product_Attribute_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Product]: {
            foreignKey: 'WB_PPA_PRODUCT_ID',
            foreignKeyImmutable: true,
            localField: 'PPAProduct'
        },
        [PASchema.esWB_PPA_Attribute]: {
            foreignKey: 'WB_PPA_ATTRIBUTE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAAttribute'
        },
        [PASchema.esWB_PPA_Attribute_Level]: {
            foreignKey: 'WB_PPA_ATTRIBUTE_LEVEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAAttributeLevel'
        }
    },
    hasMany: {}
};

// PPA Consumer Segment
export const WB_PPA_Consumer_Segment = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Consumer_Segment', // optional
    description: 'Schema for WB_PPA_Consumer_Segment records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_CONSUMER_SEGMENT_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "SEGMENT_ID": {
            "type": "string",
            "length": 50
        },
        "SEGMENT_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_MARKET_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Consumer_Segment_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Market]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarket'
        }
    },
    hasMany: {
        [PASchema.esWB_PPA_Respondent]: {
            foreignKey: 'WB_PPA_CONSUMER_SEGMENT_ID',
            foreignKeyImmutable: true,
            localField: 'PPARespondent'
        }
    }
};

// PPA Respondent
export const WB_PPA_Respondent = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Respondent', // optional
    description: 'Schema for WB_PPA_Respondent records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_RESPONDENT_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "RESPONDENT_ID": {
            "type": "string",
            "length": 50
        },
        "RESPONDENT_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_CONSUMER_SEGMENT_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Respondent_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Consumer_Segment]: {
            foreignKey: 'WB_PPA_CONSUMER_SEGMENT_ID',
            foreignKeyImmutable: true,
            localField: 'PPASegment'
        }
    },
    hasMany: {}
};

// PPA Market Weight
export const WB_PPA_Adjustment = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Adjustment', // optional
    description: 'Schema for WB_PPA_Adjustment records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_ADJUSTMENT_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_MARKET_ID": {
            "type": "number",
            "default": 0
        },
        "ADJUSTMENT_TYPE": {
            "type": "string",
            "length": 50
        },
        "FACTOR": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_BRAND_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRODUCT_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_CHANNEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRICEPRDTYPE_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Adjustment_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Channel]: {
            foreignKey: 'WB_PPA_CHANNEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAChannel'
        },
        [PASchema.esWB_PPA_Market]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarket'
        },
        [PASchema.esWB_PPA_Brand]: {
            foreignKey: 'WB_PPA_BRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPABrand'
        },
        [PASchema.esWB_PPA_Product]: {
            foreignKey: 'WB_PPA_PRODUCT_ID',
            foreignKeyImmutable: true,
            localField: 'PPAProduct'
        },
        [PASchema.esWB_PPA_PricePrdType]: {
            foreignKey: 'WB_PPA_PRICEPRDTYPE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAPriceType'
        }
    },
    hasMany: {}
};

// PPA Condition
export const WB_PPA_Condition = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Condition', // optional
    description: 'Schema for WB_PPA_Condition records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_CONDITION_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_MARKET_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRODUCT_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_BRAND_ID": {
            "type": "number",
            "default": 0
        },
        "SOURCE_ID": {
            "type": "string",
            "length": 50
        },
        "CONDITION_TYPE": {
            "type": "string",
            "length": 50
        },
        "REL_SOURCE_ID": {
            "type": "string",
            "length": 50
        },
        "VALUE_RATEAMOUNT": {
            "type": "number"
        },
        "EFFECTIVE_START_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "EFFECTIVE_END_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "PROD_CND_ID_REF": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Condition_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Market]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarket'
        },
        [PASchema.esWB_PPA_Product]: {
            foreignKey: 'WB_PPA_PRODUCT_ID',
            foreignKeyImmutable: true,
            localField: 'PPAProduct'
        },
        [PASchema.esWB_PPA_Brand]: {
            foreignKey: 'WB_PPA_BRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPABrand'
        }
    },
    hasMany: {}
};

// PPA Market Share
export const WB_PPA_Market_Share = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Market_Share', // optional
    description: 'Schema for WB_PPA_Market_Share records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_MARKET_SHARE_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_MARKET_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRODUCT_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_BRAND_ID": {
            "type": "number",
            "default": 0
        },
        "SHARE_TYPE": {
            "type": "string",
            "length": 50
        },
        "MARKET_SHARE_EQV": {
            "type": "number"
        },
        "MARKET_SHARE_PCNT": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Market_Share_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Market]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarket'
        },
        [PASchema.esWB_PPA_Product]: {
            foreignKey: 'WB_PPA_PRODUCT_ID',
            foreignKeyImmutable: true,
            localField: 'PPAProduct'
        },
        [PASchema.esWB_PPA_Brand]: {
            foreignKey: 'WB_PPA_BRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPABrand'
        }
    },
    hasMany: {}
};

// PPA Price Product Type Coefficient
export const WB_PPA_PricePrdType_Coeff = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_PricePrdType_Coeff', // optional
    description: 'Schema for WB_PPA_PricePrdType_Coeff records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_PRICEPRDTYPE_COEFF_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_PRICEPRDTYPE_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_RESPONDENT_ID": {
            "type": "number",
            "default": 0
        },
        "COEFF1": {
            "type": "number",
            "default": 0
        },
        "COEFF2": {
            "type": "number",
            "default": 0
        },
        "COEFF3": {
            "type": "number",
            "default": 0
        },
        "COEFF4": {
            "type": "number",
            "default": 0
        },
        "COEFF5": {
            "type": "number",
            "default": 0
        },
        "MAPE": {
            "type": "number",
            "default": 0
        },
        "R2": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_PricePrdType_Coeff_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_PricePrdType]: {
            foreignKey: 'WB_PPA_PRICEPRDTYPE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAPriceType'
        },
        [PASchema.esWB_PPA_Respondent]: {
            foreignKey: 'WB_PPA_RESPONDENT_ID',
            foreignKeyImmutable: true,
            localField: 'PPARespondentType'
        }
    },
    hasMany: {}
};

// PPA Scenario
export const WB_PPA_Scenario = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Scenario', // optional
    description: 'Schema for WB_PPA_Scenario records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_SCENARIO_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_MARKET_ID": {
            "type": "number",
            "default": 0
        },
        "SCENARIO_ID": {
            "type": "string",
            "length": 50
        },
        "SCENARIO_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "SCENARIO_DATE": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "MARKET_VOLUME_EQV": {
            "type": "number",
            "default": 0
        },
        "MARKET_IND": {
            "type": "string",
            "length": 1
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Scenario_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Market]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarket'
        },
        [PASchema.esWB_User]: {
            foreignKey: 'WB_AUTHUSR_ID_CREATEDBY',
            foreignKeyImmutable: true,
            localField: 'User'
        }
    },
    hasMany: {
        [PASchema.esWB_PPA_Scenario_Prd]: {
            foreignKey: 'WB_PPA_SCENARIO_ID',
            foreignKeyImmutable: true,
            localField: 'ScenarioProducts'
        }
    }
};

// PPA Scenario Product
export const WB_PPA_Scenario_Prd = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Scenario_Prd', // optional
    description: 'Schema for WB_PPA_Scenario_Prd records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_SCENARIO_PRD_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_SCENARIO_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRODUCT_ID": {
            "type": "number",
            "default": 0
        },
        "INCLUDE_IND": {
            "type": "string",
            "length": 1
        },
        "RETAIL_PRICE": {
            "type": "number",
            "default": 0
        },
        "CHANNEL_UTILITY": {
          "type": "number",
          "default": 0,
        },
        "CHANNEL_ADJ_FACTOR": {
          "type": "number",
          "default": 0,
        },
        "BRAND_UTILITY": {
          "type": "number",
          "default": 0,
        },
        "BRAND_ADJ_FACTOR": {
          "type": "number",
          "default": 0,
        },
        "SUBBRAND_UTILITY": {
          "type": "number",
          "default": 0,
        },
        "SUBBRAND_ADJ_FACTOR": {
          "type": "number",
          "default": 0,
        },
        "PRICE_UTILITY": {
          "type": "number",
          "default": 0,
        },
        "PRICE_ADJ_FACTOR": {
          "type": "number",
          "default": 0,
        },
        "ATTRIBUTE_UTILITY": {
          "type": "number",
          "default": 0,
        },
        "PRODUCT_ADJ_FACTOR": {
          "type": "number",
          "default": 0,
        },
        "TOTAL_UTILITY": {
          "type": "number",
          "default": 0,
        },
        "MARKET_SHARE_PCNT": {
            "type": "number",
            "default": 0
        },
        "MARKET_SHARE_UNITS": {
            "type": "number",
            "default": 0
        },
        "MARKET_SHARE_EQV": {
            "type": "number",
            "default": 0
        },
        "GROSS_REVENUE": {
            "type": "number",
            "default": 0
        },
        "CONTRIBUTION_MARGIN": {
            "type": "number",
            "default": 0
        },
        "RETAILER_MARGIN": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Scenario_Prd_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Scenario]: {
            foreignKey: 'WB_PPA_SCENARIO_ID',
            foreignKeyImmutable: true,
            localField: 'PPAScenario'
        },
        [PASchema.esWB_PPA_Product]: {
            foreignKey: 'WB_PPA_PRODUCT_ID',
            foreignKeyImmutable: true,
            localField: 'PPAProduct'
        }
    },
    hasMany: {}
};

// PPA Market CSR
export const WB_PPA_Market_CSR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Market_CSR', // optional
    description: 'Schema for WB_PPA_Market_CSR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_MARKET_CSR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_MARKET_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_CONSUMER_SEGMENT_ID": {
            "type": "number",
            "default": 0
        },
        "WEIGHT_PCNT": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Market_CSR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Market]: {
            foreignKey: 'WB_PPA_MARKET_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarket'
        },
        [PASchema.esWB_PPA_Consumer_Segment]: {
            foreignKey: 'WB_PPA_CONSUMER_SEGMENT_ID',
            foreignKeyImmutable: true,
            localField: 'PPASegment'
        }
    },
    hasMany: {
        [PASchema.esWB_PPA_Market_CSRR]: {
            foreignKey: 'WB_PPA_MARKET_CSR_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarketCSRRs'
        }
    }
};

// PPA Market CSRR
export const WB_PPA_Market_CSRR = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Market_CSRR', // optional
    description: 'Schema for WB_PPA_Market_CSRR records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_MARKET_CSRR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_MARKET_CSR_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_RESPONDENT_ID": {
            "type": "number",
            "default": 0
        },
        "WEIGHT_PCNT": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Market_CSRR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Respondent]: {
            foreignKey: 'WB_PPA_RESPONDENT_ID',
            foreignKeyImmutable: true,
            localField: 'PPARespondent'
        },
        [PASchema.esWB_PPA_Market_CSR]: {
            foreignKey: 'WB_PPA_MARKET_CSR_ID',
            foreignKeyImmutable: true,
            localField: 'PPAMarketCSR'
        }
    },
    hasMany: {}
};

// PPA Price Level
export const WB_PPA_PriceLevel = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_PriceLevel', // optional
    description: 'Schema for WB_PPA_PriceLevel records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_PRICELEVEL_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "LEVEL_ID": {
            "type": "string",
            "length": 50
        },
        "LEVEL_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_PriceLevel_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        }
    },
    hasMany: {}
};

// PPA Respondent Utility
export const WB_PPA_Respondent_Utility = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Respondent_Utility', // optional
    description: 'Schema for WB_PPA_Respondent_Utility records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_RESPONDENT_UTILITY_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_RESPONDENT_ID": {
            "type": "number",
            "default": 0
        },
        "UTILITY_TYPE": {
            "type": "string",
            "length": 50
        },
        "WB_PPA_ATTRIBUTE_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_ATTRIBUTE_LEVEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRICEPRDTYPE_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_PRICELEVEL_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_BRAND_ID": {
            "type": "number",
            "default": 0
        },
        "WB_PPA_CHANNEL_ID": {
            "type": "number",
            "default": 0
        },
        "UTILITY": {
            "type": "number",
            "default": 0
        },
        "RETAIL_PRICE": {
            "type": "number",
            "default": 0
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Respondent_Utility_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        },
        [PASchema.esWB_PPA_Respondent]: {
            foreignKey: 'WB_PPA_RESPONDENT_ID',
            foreignKeyImmutable: true,
            localField: 'PPARespondent'
        },
        [PASchema.esWB_PPA_Channel]: {
            foreignKey: 'WB_PPA_CHANNEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAChannel'
        },
        [PASchema.esWB_PPA_Brand]: {
            foreignKey: 'WB_PPA_BRAND_ID',
            foreignKeyImmutable: true,
            localField: 'PPABrand'
        },
        [PASchema.esWB_PPA_Attribute]: {
            foreignKey: 'WB_PPA_ATTRIBUTE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAAttribute'
        },
        [PASchema.esWB_PPA_Attribute_Level]: {
            foreignKey: 'WB_PPA_ATTRIBUTE_LEVEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAAttributeLevel'
        },
        [PASchema.esWB_PPA_PricePrdType]: {
            foreignKey: 'WB_PPA_PRICEPRDTYPE_ID',
            foreignKeyImmutable: true,
            localField: 'PPAPriceType'
        },
        [PASchema.esWB_PPA_PriceLevel]: {
            foreignKey: 'WB_PPA_PRICELEVEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAPriceLevel'
        }
    },
    hasMany: {}
};

// PPA Manufacturer
export const WB_PPA_Manufacturer = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_PPA_Manufacturer', // optional
    description: 'Schema for WB_PPA_Manufacturer records', // optional
    type: 'object',
    track: true,
    "properties": {
        "WB_PPA_MANUFACTURER_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "MANUFACTURER_ID": {
            "type": "string",
            "length": 50
        },
        "MANUFACTURER_NAME": {
            "type": "string",
            "default": "",
            "length": 250
        },
        "WB_PPA_MODEL_ID": {
            "type": "number",
            "default": 0
        },
        "COMPETITOR_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
});
export const WB_PPA_Manufacturer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PPA_Model]: {
            foreignKey: 'WB_PPA_MODEL_ID',
            foreignKeyImmutable: true,
            localField: 'PPAModel'
        }
    },
    hasMany: {}
};

// Reference by mapper
_.defaults(dctSchemaByEntitySet,
    {
        [PASchema.esWB_PPA_Model]: WB_PPA_Model,
        [PASchema.esWB_PPA_Manufacturer]: WB_PPA_Manufacturer,
        [PASchema.esWB_PPA_Market]: WB_PPA_Market,
        [PASchema.esWB_PPA_Channel]: WB_PPA_Channel,
        [PASchema.esWB_PPA_Brand]: WB_PPA_Brand,
        [PASchema.esWB_PPA_SubBrand]: WB_PPA_SubBrand,
        [PASchema.esWB_PPA_Attribute]: WB_PPA_Attribute,
        [PASchema.esWB_PPA_Attribute_Level]: WB_PPA_Attribute_Level,
        [PASchema.esWB_PPA_PricePrdType]: WB_PPA_PricePrdType,
        [PASchema.esWB_PPA_PricePrdType_Level]: WB_PPA_PricePrdType_Level,
        [PASchema.esWB_PPA_Product]: WB_PPA_Product,
        [PASchema.esWB_PPA_Product_Attribute]: WB_PPA_Product_Attribute,
        [PASchema.esWB_PPA_Consumer_Segment]: WB_PPA_Consumer_Segment,
        [PASchema.esWB_PPA_Respondent]: WB_PPA_Respondent,
        [PASchema.esWB_PPA_Adjustment]: WB_PPA_Adjustment,
        [PASchema.esWB_PPA_Condition]: WB_PPA_Condition,
        [PASchema.esWB_PPA_Market_Share]: WB_PPA_Market_Share,
        [PASchema.esWB_PPA_PricePrdType_Coeff]: WB_PPA_PricePrdType_Coeff,
        [PASchema.esWB_PPA_Scenario]: WB_PPA_Scenario,
        [PASchema.esWB_PPA_Scenario_Prd]: WB_PPA_Scenario_Prd,
        [PASchema.esWB_PPA_Market_CSR]: WB_PPA_Market_CSR,
        [PASchema.esWB_PPA_Market_CSRR]: WB_PPA_Market_CSRR,
        [PASchema.esWB_PPA_PriceLevel]: WB_PPA_PriceLevel,
        [PASchema.esWB_PPA_Respondent_Utility]: WB_PPA_Respondent_Utility
    });

// These tables need to be moved into the JSData Schemas
_.defaults(dctTableNameByEntitySet,
    {
        [PASchema.esWB_PPA_Model]: "/AZR/WB_PPA_MODEL",
        [PASchema.esWB_PPA_Manufacturer]: "/AZR/WB_PPA_MANUFACTURER",
        [PASchema.esWB_PPA_Market]: "/AZR/WB_PPA_MARKET",
        [PASchema.esWB_PPA_Channel]: "/AZR/WB_PPA_CHANNEL",
        [PASchema.esWB_PPA_Brand]: "/AZR/WB_PPA_BRAND",
        [PASchema.esWB_PPA_SubBrand]: "/AZR/WB_PPA_SUBBRAND",
        [PASchema.esWB_PPA_Attribute]: "/AZR/WB_PPA_ATTRIBUTE",
        [PASchema.esWB_PPA_Attribute_Level]: "/AZR/WB_PPA_ATTRIBUTE_LEVEL",
        [PASchema.esWB_PPA_PricePrdType]: "/AZR/WB_PPA_PRICEPRDTYPE",
        [PASchema.esWB_PPA_PricePrdType_Level]: "/AZR/WB_PPA_PRICEPRDTYPE_LEVEL",
        [PASchema.esWB_PPA_Product]: "/AZR/WB_PPA_PRODUCT",
        [PASchema.esWB_PPA_Product_Attribute]: "/AZR/WB_PPA_PRODUCT_ATTRIBUTE",
        [PASchema.esWB_PPA_Consumer_Segment]: "/AZR/WB_PPA_CONSUMER_SEGMENT",
        [PASchema.esWB_PPA_Respondent]: "/AZR/WB_PPA_RESPONDENT",
        [PASchema.esWB_PPA_Adjustment]: "/AZR/WB_PPA_ADJUSTMENT",
        [PASchema.esWB_PPA_Condition]: "/AZR/WB_PPA_CONDITION",
        [PASchema.esWB_PPA_Market_Share]: "/AZR/WB_PPA_MARKET_SHARE",
        [PASchema.esWB_PPA_PricePrdType_Coeff]: "/AZR/WB_PPA_PRICEPRDTYPE_COEFF",
        [PASchema.esWB_PPA_Scenario]: "/AZR/WB_PPA_SCENARIO",
        [PASchema.esWB_PPA_Scenario_Prd]: "/AZR/WB_PPA_SCENARIO_PRD",
        [PASchema.esWB_PPA_Market_CSR]: "/AZR/WB_PPA_MARKET_CSR",
        [PASchema.esWB_PPA_Market_CSRR]: "/AZR/WB_PPA_MARKET_CSRR",
        [PASchema.esWB_PPA_PriceLevel]: "/AZR/WB_PPA_PRICELEVEL",
        [PASchema.esWB_PPA_Respondent_Utility]: "/AZR/WB_PPA_RESPONDENT_UTILITY"


    });

// TODO: Complete logical keys for metadata export
_.defaults(dctLogicalKeysByEntitySet, {});

//maps tables to foreign keys that aren't part of JSDataRels for dataexporter/importer
//TODO: Fill out foreign key references that aren't part of the natural key
_.defaults(dctNonParentForeignKeysByEntitySet,
    {});

_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_PPA_Model]: { sequence_name: "/AZR/WB_PPA_MODEL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Manufacturer]: { sequence_name: "/AZR/WB_PPA_MANUFACTURER_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Market]: { sequence_name: "/AZR/WB_PPA_MARKET_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Channel]: { sequence_name: "/AZR/WB_PPA_CHANNEL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Brand]: { sequence_name: "/AZR/WB_PPA_BRAND_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_SubBrand]: { sequence_name: "/AZR/WB_PPA_SUBBRAND_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Attribute]: { sequence_name: "/AZR/WB_PPA_ATTRIBUTE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Attribute_Level]: { sequence_name: "/AZR/WB_PPA_ATTRIBUTE_LEVEL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_PricePrdType]: { sequence_name: "/AZR/WB_PPA_PRICEPRDTYPE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_PricePrdType_Level]: { sequence_name: "/AZR/WB_PPA_PRICEPRDTYPE_LEVEL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Product]: { sequence_name: "/AZR/WB_PPA_PRODUCT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Product_Attribute]: { sequence_name: "/AZR/WB_PPA_PRODUCT_ATTRIBUTE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Consumer_Segment]: { sequence_name: "/AZR/WB_PPA_CONSUMER_SEGMENT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Respondent]: { sequence_name: "/AZR/WB_PPA_RESPONDENT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Adjustment]: { sequence_name: "/AZR/WB_PPA_ADJUSTMENT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Condition]: { sequence_name: "/AZR/WB_PPA_CONDITION_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Market_Share]: { sequence_name: "/AZR/WB_PPA_MARKET_SHARE_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_PricePrdType_Coeff]: { sequence_name: "/AZR/WB_PPA_PRICEPRDTYPE_COEFF_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Scenario]: { sequence_name: "/AZR/WB_PPA_SCENARIO_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Scenario_Prd]: { sequence_name: "/AZR/WB_PPA_SCENARIO_PRD_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Market_CSR]: { sequence_name: "/AZR/WB_PPA_MARKET_CSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Market_CSRR]: { sequence_name: "/AZR/WB_PPA_MARKET_CSRR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_PriceLevel]: { sequence_name: "/AZR/WB_PPA_PRICELEVEL_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PPA_Respondent_Utility]: { sequence_name: "/AZR/WB_PPA_RESPONDENT_UTILITY_SEQ", ...KeyGenSpecs_default }
});
